import React from "react";
import { $generateHtmlFromNodes } from "@lexical/html";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import LexicalErrorBoundary from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";

import useEditorFocus from "./helpers/useEditorFocus";
import AutoLinkPlugin from "./plugins/AutoLinkPlugin";
import LoadDefaultValues from "./plugins/LoadDefaultValues";
import LocalStoragePlugin from "./plugins/LocalStoragePlugin";
import MaxLengthPlugin from "./plugins/MaxLengthPlugin";
import OnBlurPlugin from "./plugins/OnBlurPlugin";
import PlaceHolderPlugin from "./plugins/PlaceHolderPlugin";
import ToolbarPlugin from "./plugins/ToolbarPlugin";

import styles from "./editor.module.scss";

type LexicalContainerProps = {
	namespace: string;
	editable?: boolean;
	defaultValues?: string;
	maxLength: number;
	onChange: Function;
	onBlur?: Function;
};

const LexicalContainer = ({
	namespace,
	editable = true,
	defaultValues = "",
	maxLength,
	onChange,
	onBlur,
}: LexicalContainerProps) => {
	const onChangeHandler = (editorState, editor) => {
		editorState?.read(() => {
			onChange?.($generateHtmlFromNodes(editor, null));
		});
	};

	return (
		<div
			className={`${styles.editorContainer} ${
				useEditorFocus() ? `${styles.editorFocused}` : ""
			}  `}
		>
			<LoadDefaultValues defaultValues={defaultValues} />
			<LocalStoragePlugin namespace={namespace} />
			<OnChangePlugin onChange={onChangeHandler} ignoreSelectionChange />
			<OnBlurPlugin onBlur={onBlur} />
			<MaxLengthPlugin maxLength={maxLength} />
			<ToolbarPlugin editable={editable} />
			<div className={styles.editorInner}>
				<RichTextPlugin
					contentEditable={
						<ContentEditable className={styles.editorInput} />
					}
					placeholder={<PlaceHolderPlugin />}
					ErrorBoundary={LexicalErrorBoundary}
				/>
				<HistoryPlugin />
				<ListPlugin />
				<LinkPlugin />
				<AutoLinkPlugin />
			</div>
		</div>
	);
};

export default LexicalContainer;
